import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCircleSolidIconSecondary from './svgs/CircleSolidIconSecondary.js';
import SvgCircleSolidIcon from './svgs/CircleSolidIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var CircleSolidIcon = (props => useIcon(SvgCircleSolidIcon, SvgCircleSolidIconSecondary, props));

export { CircleSolidIcon as default };
